let registration: Promise<void> | undefined;

/**
 * Lazily loads Swiper's custom elements (`<swiper-container>` / `<swiper-slide>`)
 * and all its modules, exactly once. Call this from any component that renders a
 * Swiper element - ideally in `ngOnInit`, or when the element is about to appear.
 *
 * Keeping this out of `main.ts` / `SharedModule` moves ~210 kB of Swiper out of
 * the initial bundle into an on-demand chunk. Elements that mount before
 * registration completes upgrade automatically once it does.
 */
export function ensureSwiperElements(): Promise<void> {
  if (!registration) {
    registration = import('swiper/element/bundle').then(({ register }) => register());
  }
  return registration;
}
